import { useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { auth } from '@/lib/firebase';

export default function DashboardRedirect() {
  const { user, role, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      const currentUser = auth.currentUser;
      
      // Si no hay usuario en el contexto ni en Firebase, redirigir a login
      if (!user && !currentUser) {
        navigate('/crm/login');
        return;
      }
      
      // Si hay usuario en Firebase pero aún no en el contexto, esperar a que el contexto se actualice
      if (!user && currentUser) {
        return;
      }

      if (user && !user.emailVerified && role === 'client') {
        navigate('/crm/verify-email');
        return;
      }
      
      if (role === 'admin') {
        navigate('/crm/admin');
      } else if (role === 'employee') {
        navigate('/crm/employee');
      } else if (role === 'client') {
        navigate('/crm/client');
      } else {
        // Si no tiene rol o algo falla, lo mandamos al login o inicio
        navigate('/crm/login');
      }
    }
  }, [role, loading, navigate, user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white">
      <div className="flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500"></div>
        <p className="text-slate-400 text-sm">Redirigiendo a tu panel...</p>
      </div>
    </div>
  );
}
